interface NodeRichText {
	data: any
	content: NodeRichText[]
	marks?: { type: string }[]
	value?: string
	nodeType: string
	sys?: {
		id: string
		type: string
		linkType: string
	}
	uri?: string
}

export const getTextFromRichText = (richText: NodeRichText): string => {
	let concatenatedValues: string = ''

	const traverse = (richTextElement: NodeRichText) => {
		if (richTextElement.nodeType === 'text' && richTextElement.value) {
			concatenatedValues += richTextElement.value
		}

		if (richTextElement.content) {
			richTextElement.content.forEach((childNode) => traverse(childNode))
		}
	}

	traverse(richText)

	return concatenatedValues
}
